'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/* istanbul ignore next */
var customEventConstructorPolyfill = function customEventConstructorPolyfill() {
    // Polyfill the CustomEvent() constructor functionality in Internet Explorer 9 and higher
    if (typeof window.CustomEvent === 'function') {
        return false;
    }

    function CustomEvent(event, params) {
        var options = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, options.bubbles, options.cancelable, options.detail);
        return evt;
    }
    CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent;
    return true;
};

exports.default = customEventConstructorPolyfill;


//////////////////
// WEBPACK FOOTER
// ./~/rp-mq-breakpoints/lib/custom-event-constructor-polyfill.js
// module id = 1771
// module chunks = 1